import React, { useState } from 'react';
import { message, Modal, Upload } from 'antd';
import { UploadOutlined, LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';

import { useOrderDetail } from '../../hooks/data/useOrders';

interface UploadInvoiceModalProps {
  orderId: string;
  onClose: () => void;
  onSuccess: () => void;
}

export const UploadInvoiceModal: React.FC<UploadInvoiceModalProps> = ({
  orderId,
  onClose,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);

  const { getInvoiceUrl, refreshOrderDetail } = useOrderDetail(orderId);

  const uploadInvoice = (options: any) => {
    if(loading) return;
    setLoading(true);

    getInvoiceUrl().then((response) => {
      if(response === false || response === true || response === undefined){
        message.error("The request of the upload signed url failed! Could not upload invoice!");
        setLoading(false);
        return;
      }

      const signedUrl = response.data;
      if(!signedUrl){
        message.error("Invalid signed url! Could not upload invoice!");
        setLoading(false);
        return;
      }
      
      return axios.put(signedUrl, options.file);
    }).then(() => {
      message.success('Invoice uploaded!');
      refreshOrderDetail();
      onClose();
    })
    .catch(() => {
      message.error('Could not upload invoice!');
      setLoading(false);
    });;
  };

  return (
    <Modal title={'Upload invoice'} open={true} onCancel={onClose}>
      <Upload.Dragger
        showUploadList={false}
        customRequest={uploadInvoice}
        accept={'application/pdf'}
        disabled={loading}>
        {!loading ? (
          <>
            <UploadOutlined />
            <br />
            Upload an invoice
          </>
        ) : (
          <LoadingOutlined />
        )}
      </Upload.Dragger>
    </Modal>
  );
};
